<template>
    <v-dialog v-model="modalState">
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon small>mdi-plus</v-icon>
                <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.newExercises || "New Exercise" }}</span>
            </v-btn>
        </template>
        <template v-slot:default="newExercise">
            <v-card>
                <v-toolbar elevation="0">
                    <v-toolbar-title>New Exercise</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="newExercise.value = false"> 
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container class="mt-4">
                    <v-row>
                        <v-col cols="12">
                                <label class="custom-label">{{ $page.props.lang.name || 'Name' }}</label>
                                <v-text-field v-model="exercise.name" 
                                    :error-messages="responseErrors.name" 
                                    :hide-details="!responseErrors.name"
                                    @focus="responseErrors.name=''" 
                                    outlined dense solo flat></v-text-field>
                            </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                                <label class="custom-label">{{ $page.props.lang.description || 'Description' }}</label>
                                <v-textarea v-model="exercise.description" 
                                    :error-messages="responseErrors.description" 
                                    :hide-details="!responseErrors.description"
                                    @focus="responseErrors.description=''" 
                                    outlined dense solo flat></v-textarea>
                            </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                                <label class="custom-label">{{ $page.props.lang.videoUrl || 'Video URL' }}</label>
                                <v-text-field v-model="exercise.url" 
                                    :error-messages="responseErrors.url" 
                                    :hide-details="!responseErrors.url"
                                    @focus="responseErrors.url=''" 
                                    outlined dense solo flat></v-text-field>
                            </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12"> 
                            <p class="custom-label">{{ $page.props.lang.table_category || 'Category' }}</p>
                            <v-select v-model="exercise.category_id" 
                                :items="categoriesData"
                                item-text="name"
                                item-value="id"
                                :error-messages="responseErrors.category_id" @change="responseErrors.category_id=''" 
                                class="period-select" outlined dense :hide-details="!responseErrors.category_id"></v-select>
                            <ManageCategories></ManageCategories>
                        </v-col>
                    </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="newExercise.value = false" color="regular">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                    <v-btn :loading="saving" @click="addExercise" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>

<script>
import ManageCategories from '../../Categories/Components/ManageCategories';
import EventBus from '@/js/eventbus'

export default {
    components:{
        ManageCategories
    },
    props:{
        categories: {
            type: Array,
            required: true
        }
    },
    data(){
        return {
            modalState: false,
            exercise: {
                name: '',
                description: '',
                category_id: null
            },
            saving:false,
            categoriesData: this.categories,
            responseErrors: {}
        }
    },
    created() {

        EventBus.$on('NEW_CATEGORY_ADDED', (payload) => {
            this.categoriesData.push(
                {
                    id: payload.id,
                    name: payload.name
                });
            this.exercise.category_id = payload.id;
        });
    },
    methods:{

        addExercise(){
            axios.post('/backoffice/exercises/store', this.exercise)
            .then(response => {

                if(response.data.status == "OK"){
                    this.modalState = false;
                }
            })
            .catch(error => {

                    this.saving = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        }
    }
}
</script>